export default __webpack_public_path__ + "static/docs-6bb768780a720ae9b556949c548f9207.png";